module.exports = __webpack_public_path__ + "static/media/filterClose.433ef1f6.svg";